// // src/pages/SchoolLandingPage.jsx

// import React, { useEffect, useState } from "react";
// import SchoolHeader from "./SchoolHeader";
// import BannerCarousel from "./BanerCarousel";
// import AboutSection from "./AboutSection";
// import NoticeBoard from "./NoticeBoard";
// import NewsEvents from "./NewsEvent";
// import SchoolFooter from "./SchoolFooter";

// const SchoolLandingPage = () => {
//   const [school, setSchool] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchSchool = async () => {
//       try {
//         // Extract subdomain from window.location.hostname
//         const hostParts = window.location.hostname.split('.');
  
//         // Safety check: ensure there's actually a subdomain
//         const subdomain = hostParts.length > 2 ? hostParts[0] : null;
  
//         if (!subdomain) {
//           setError("No subdomain found in the URL.");
//           setLoading(false);
//           return;
//         }
  
//         const res = await fetch(`http://localhost:4000/api/v1/getSchoolBySubdomain/${subdomain}`);
//         const data = await res.json();
  
//         if (!data.success) {
//           setError(data.message || "Failed to load school info.");
//           return;
//         }
  
//         setSchool(data.school);
//       } catch (err) {
//         console.error("Error fetching school:", err);
//         setError("Something went wrong. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
  
//     fetchSchool();
//   }, []);
  

//   if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
//   if (error) return <div className="min-h-screen flex items-center justify-center text-red-500">{error}</div>;
//   if (!school) return null;

//   return (
//     <div className="bg-gray-100 text-gray-900">
//       <SchoolHeader school={school} />
//       <BannerCarousel images={school.banner} />
//       <AboutSection school={school} />
//       <NoticeBoard />
//       <NewsEvents />
//       <SchoolFooter school={school} />
//     </div>
//   );
// };

// export default SchoolLandingPage;



// src/pages/SchoolLandingPage.jsx

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchoolBySubdomain } from "../features/school/schoolSlice";

import SchoolHeader from "./SchoolHeader";
import BannerCarousel from "./BanerCarousel";
import AboutSection from "./AboutSection";
import NoticeBoard from "./NoticeBoard";
import NewsEvents from "./NewsEvent";
import SchoolFooter from "./SchoolFooter";

const SchoolLandingPage = () => {
  const dispatch = useDispatch();

  const { school, loading, error } = useSelector((state) => state.school);

  console.log("School from Redux:", school);

  useEffect(() => {
    const hostParts = window.location.hostname.split(".");
    const subdomain = hostParts.length > 2 ? hostParts[0] : null;

    
console.log("Using subdomain:", subdomain);

    if (!subdomain) {
      console.error("No valid subdomain found.");
      return;
    }

    dispatch(fetchSchoolBySubdomain(subdomain));
  }, [dispatch]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-500">
        {error}
      </div>
    );
  }

  if (!school) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        School not found.
      </div>
    );
  }

  return (
    <div className="bg-gray-100 text-gray-900">
      <SchoolHeader school={school} />
      <BannerCarousel images={school.banner} />
      <AboutSection school={school} />
      <NoticeBoard />
      <NewsEvents />
      <SchoolFooter school={school} />
    </div>
  );
};

export default SchoolLandingPage;

